import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../../utils/rel';

class NewsTitleAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        if (!content || content.length === 0) return <div />;

        /* eslint-disable no-confusing-arrow */
        return (
            <div id="newsTitleAd" className={styles.title_ad}>
                {content.map(
                    (item, index) =>
                        item.children && item.children.length > 0 ? (
                            <React.Fragment key={index}>
                                <a href={item.url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                                {item.children.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <a href={item.url} target="_blank" rel={rel}>
                                            {item.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a key={index} href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        ),
                )}
            </div>
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(NewsTitleAd);
